import React, {useCallback, useEffect, useMemo, useState} from "react"
import {useSelector} from "react-redux"
import {Button, Card, Drawer, Table} from "antd"
import {center} from "../../../helps/tableHelper"
import {getDaysView, getTimeRange, TimeValue} from "../../../helps/scheduleHelper"
import {getObjectGroupSchedules, setObjectGroupSchedules, setWSObjectGroupSchedule} from "../../../store/objectGroupScheduleReducer"
import {StateType} from "../../../store/store"
import {Loading} from "../../../components/Loading/Loading"
import {ObjectGroupScheduleForm} from "./ObjectGroupScheduleForm"

type PropsType = {
    idGroup: number
    dispatch: any
    showModalSchedules: boolean
    setShowModalSchedules: (value: boolean) => void
}
export const ObjectGroupSchedules: React.FC<PropsType> = ({idGroup, dispatch, showModalSchedules, setShowModalSchedules}) => {
    const schedules = useSelector((state: StateType) => state.objectGroupScheduleReducer.schedules)
    const ws = useSelector((state: StateType) => state.objectGroupScheduleReducer.ws)
    const controller = useMemo(() => new AbortController(), [])
    const [showModalSchedule, setShowModalSchedule] = useState(false)
    const [selectedSchedule, setSelectedSchedule] = useState<any>(null)

    const columns = useMemo(() => [
        {
            title: 'Действие',
            dataIndex: 'security',
            key: 'security',
            align: center,
            render: (security: boolean) => {
                return security ? 'Постановка' : 'Снятие'
            },
        },
        {
            title: 'Дни',
            dataIndex: 'days',
            key: 'days',
            render: (days: Array<number>) => {
                return getDaysView(days)
            },
            align: center,
        },
        {
            title: 'Время',
            dataIndex: 'time',
            key: 'time',
            render: (time: TimeValue) => {
                return getTimeRange(time)
            },
            align: center,
        },
    ], [])

    const onClose = () => {
        setShowModalSchedules(false)
    }

    const getSchedulesFunc = useCallback((withoutLoadingIndicator = false) => {
        dispatch(getObjectGroupSchedules({
            idGroup,
            withoutLoadingIndicator,
            controller,
        }))
    }, [dispatch, controller])

    useEffect(() => {
        getSchedulesFunc()

        return () => {
            dispatch(setObjectGroupSchedules(null))
        }
    }, [dispatch, getSchedulesFunc])

    useEffect(() => {
        return () => {
            controller.abort()
        }
    }, [dispatch, controller])

    useEffect(() => {
        if (ws) {
            getSchedulesFunc(true)
        }
        dispatch(setWSObjectGroupSchedule(null))
    }, [dispatch, ws, getSchedulesFunc])

    const data = useMemo(() => schedules?.data?.map(i => {
        return {
            key: i.id,
            id: i.id,
            security: i.security,
            days: i.days,
            time: {
                hour: i.hour,
                minute: i.minute,
            },
            comment: i.comment,
        }
    }), [schedules])

    return (
        <Drawer title="Расписание"
                placement="right"
                width={500}
                onClose={onClose}
                open={showModalSchedules}
                extra={<Button onClick={() => setShowModalSchedule(true)} type="link" size="middle" style={{marginTop: 5}}>Добавить</Button>}
                bodyStyle={{padding: 0}}
        >
            <Card variant="borderless"
                  className="criclebox tablespace"
                  style={{borderRadius: 0}}
            >
                <div className="table-responsive">
                    {
                        schedules
                            ? <Table columns={columns}
                                     dataSource={data}
                                     pagination={false}
                                     className="ant-border-space"
                                     onRow={(i) => ({
                                         onClick: () => {
                                             setSelectedSchedule(i)
                                             setShowModalSchedule(true)
                                         },
                                     })}
                            />
                            : <Loading/>
                    }
                </div>
            </Card>

            {
                showModalSchedule
                    ? <ObjectGroupScheduleForm showModalSchedule={showModalSchedule}
                                               setShowModalSchedule={setShowModalSchedule}
                                               selectedSchedule={selectedSchedule}
                                               setSelectedSchedule={setSelectedSchedule}
                                               dispatch={dispatch}
                                               controller={controller}
                                               idGroup={idGroup}
                    />
                    : null
            }
        </Drawer>
    )
}